import {MenuItem, TextField} from '@material-ui/core';
import React from 'react';
import './input.css';

const Input = ({SelectProps, ...props}: any) => {
  if (!SelectProps) {
    return <TextField variant="outlined" {...props} />;
  }

  const {options, ...selectProps} = SelectProps;
  const selectClass = selectProps.value ? '' : 'initial-value-selected';

  return (
    <TextField
      variant="outlined"
      {...props}
      SelectProps={selectProps}
      className={selectClass}
    >
      {options.map((option: any) => (
        <MenuItem
          value={option.value}
          key={`selectOption#${option.value}`}
          disabled={option.value === 0}
        >
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default Input;



// WEBPACK FOOTER //
// ./src/shared/components/inputs/Input.tsx